export const tradeFairDates = {
	start: '2024-09-20',
	end: '2024-09-30',
} as const;

export type TradeFairDatesType = {
    start: string | Date;
    end: string | Date;
};


export const tradeFairWeeks = [
	'2025.43',
	'2025.45',
	'2025.47',
	'2025.48',
	'2025.49',

] as const;

export const tradeFairWeekNumbers = [
	{ weekNr: 43 },
	{ weekNr: 45 },
	{ weekNr: 47 },
	{ weekNr: 48 },
	{ weekNr: 49 },
];
